import { color } from "./variables"
import { css } from "emotion/macro"

export const input = css`
  border: 1px solid ${color.rgb.gray[2]};
  font-weight: 300;
  line-height: 20px;
  font-size: 14px;
  letter-spacing: 0.2px;
  padding: 14px 32px;
  position: relative;

  &.form-error {
    border-color: ${color.rgb.red[0]};
  }
`

export const formInputError = css`
  color: ${color.rgb.red[0]};
  background: ${color.rgba.red(0.1)[0]};
  border: 1px solid ${color.rgba.red(0.1)[0]};
  padding: 0 5px;
  display: block;
  /* width: calc(100% - 10px); */
  width: 100%;
  font-size: 12px;
`

export const inputRequired = css`
  position: relative;

  > input {
    width: calc(100% - 64px);
  }

  &::before {
    content: "*";
    display: block;
    position: absolute;
    font-size: 10px;
    color: ${color.rgb.red[0]};
    left: 8px;
    top: 0;
    z-index: 2;
  }
`

export const inputGroup2Columns = css`
  display: flex;
  justify-content: space-between;
  margin: -10px;

  > * {
    width: 50%;
    margin: 20px 10px;
  }
`

export const inputGroupColumn = css`
  display: flex;
  flex-direction: column;

  > * {
    margin: 10px 0;
  }
`

export const form = css`
  display: flex;
  flex-direction: column;
  width: 600px;
  max-width: 100%;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: 30px;
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/form-fields.js